/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Already_ReceivedInputs */

const en_po_issue_already_received = /** @type {(inputs: Po_Issue_Already_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has receipts: it cannot leave the order, close it once the purchase order is confirmed`)
};

/**
* | output |
* | --- |
* | "has receipts: it cannot leave the order, close it once the purchase order is confirmed" |
*
* @param {Po_Issue_Already_ReceivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_already_received = /** @type {((inputs?: Po_Issue_Already_ReceivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Already_ReceivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_already_received(inputs)
});